module.exports = __webpack_public_path__ + "static/best-est-roi-fall-7ec7a42ca4b35573df718ff705422ccf.svg";